<div class="row" [ngClass]="markedAsRead ? 'read-notifications' : null">
    <div class="col-md-8">
        <h5>
            <ng-container *ngIf="this.event_metadata.change_type === 'added'">
                <i class="fal fa-user-plus"></i>
            </ng-container>
            <ng-container *ngIf="this.event_metadata.change_type !== 'added'">
                <i class="fal fa-user-minus"></i>
            </ng-container>
            Person of Significant Control {{event_metadata.change_type | titlecase}} - {{event_metadata.name}} - {{eventDate | date:'d MMM y'}}
        </h5>
        <hr>
        <div *ngFor="let notification of notifications">
            <div notification-search-term
                 [notification]="notification"
                 [searchTermLink]=""
                 [searchTermString]=""
            ></div>
        </div>
        <div class="row small-margin-top">
            <div class="col-md-12">
                <a href="/profile/{{companyNumber}}" target="_blank">
                    <span class="badge badge-link">
                        <i class="fal fa-external-link"></i>
                        &nbsp;View company page
                    </span>
                </a>
            </div>
        </div>
    </div>
    <div class="align-self-center" right-image
        [imageLink]="'https://images.unsplash.com/photo-1431540015161-0bf868a2d407?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2970&q=80'"
    ></div>
</div>

